import { useState } from "react";
import dayjs from "dayjs";
import { IChart } from "../../../../../@types/chart.type";
import iconDelete from "./../../../../../assets/_TrashIcon_gray.svg";
import { IconUnavailableCollaborators } from "../../../../../icons/IconUnavailableCollaborators";
import { GridBaseWidget } from "../../GridBaseWidget";
import { ColDef, IGetRowsParams } from "ag-grid-community";
import { getAllUnavailableResources } from "../../../../../services/api/widgets/widgetsService";
import { IApiResponse } from "../../../../../@types/api-response.type";
import { storageUserGet } from "../../../../../storage/storageUser";
import { IAllUnavailableResourcesDto } from "../../../../../@types/widgets.type";
import { CustomCellRendererProps } from "ag-grid-react";
import styles from "./styles.module.scss";

interface CompanyUnavailableResourcesProps {
  chart: IChart;
  ismodeEdit: boolean;
  deleteChart: (id: string | undefined, widgetId: string) => void;
  rowHeightGrid: number;
}

const columns: ColDef[] = [
  {
    field: "id",
    headerName: "ID",
    hide: true,
  },
  {
    field: "resourceName",
    headerName: "Nome",
    flex: 1,
  },
  {
    field: "reason",
    headerName: "Motivo",
    flex: 1,
  },
  {
    field: "returnDate",
    headerName: "Data para retorno",
    flex: 1,
    cellRenderer: (params: CustomCellRendererProps) => {
      return dayjs(params.value).format("DD/MM/YYYY");
    },
  },
];

export function CompanyUnavailableResources({
  chart,
  deleteChart,
  ismodeEdit,
}: CompanyUnavailableResourcesProps) {
  const [loading, setLoading] = useState<boolean>(false);

  const user = storageUserGet();

  async function fetchAllUnavailableResources(params: IGetRowsParams) {
    const skip = params.startRow; // Linha inicial para paginação
    const take = params.endRow - params.startRow; // Quantidade de linhas

    try {
      setLoading(true);
      const response = (await getAllUnavailableResources(
        skip,
        take,
        user.email,
        user?.resourceId as string
      )) as IApiResponse<IAllUnavailableResourcesDto>;

      if (response.statusCode === 200) {
        params.successCallback(
          response.result.unavailableResource,
          response.result.unavailableResourceCount
        );
      }
    } catch (error) {
      console.log(error);
      params.failCallback();
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.widget}>
      <div className={styles.header}>
        <h3>
          <IconUnavailableCollaborators size={26} />
          Colaboradores Indisponíveis da Empresa
        </h3>
      </div>
      <div style={{ width: "100%", height: "100%" }}>
        <GridBaseWidget
          columns={columns}
          fetchData={fetchAllUnavailableResources}
          loading={loading}
        />
      </div>
      {ismodeEdit && (
        <button onClick={() => deleteChart(chart.id, chart.widgetId)}>
          <img src={iconDelete} alt="" />
        </button>
      )}
    </div>
  );
}
